import { render, staticRenderFns } from "./ValidateCertification.vue?vue&type=template&id=92f29c98&scoped=true&"
import script from "./ValidateCertification.vue?vue&type=script&lang=js&"
export * from "./ValidateCertification.vue?vue&type=script&lang=js&"
import style0 from "./ValidateCertification.vue?vue&type=style&index=0&id=92f29c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f29c98",
  null
  
)

export default component.exports